const serial = (list, data, resolve, reject) => {
  if (list.length > 0) {
    let promise = (list.shift())(data)
    if (promise) {
      promise.then(value => {
        data.push(value)
        serial(list, data, resolve, reject)
      }).catch(error => {
        data.push(error)
        reject(data)
      })
    } else {
      data.push(null)
      serial(list, data, resolve, reject)
    }
  } else resolve(data)
}

Promise.serial = function (promiseFactoryList) {
  let data = []
  return new Promise((resolve, reject) => serial(promiseFactoryList, data, resolve, reject))
}

Promise.cache = function (promiseFactory, deadTime = -1) {
  let promises = {}
  return (...params) => {
    const now = Date.now()
    let key = JSON.stringify(params)
    if (
      !promises[key] ||
      deadTime === 0 || //deadTime=0//不缓存，每次新请求
      (deadTime > 0 && now - promises[key].timestamp > deadTime) //deadTime=-1//不过期，仅首次请求
    ) promises[key] = {
      promise: promiseFactory.apply(null, params),
      timestamp: now
    }
    return promises[key].promise
  }
}